import type { GiftTier } from '../types/site'

/**
 * Zet de laagste trede (gratis verzending) op het bedrag uit Verzending; de rest blijft staan.
 * Eén bron: Instellingen › Webshop & verzending bepaalt het bedrag, de cadeaustaffel volgt.
 */
export function withFreeShippingTier(tiers: GiftTier[], from: number): GiftTier[] {
  if (tiers.length === 0) return tiers
  const first = tiers.reduce((low, t) => (t.threshold < low.threshold ? t : low))
  return tiers.map((t) => (t === first ? { ...t, threshold: from, ruleId: `free-shipping-${from}` } : t))
}

/** Eén cadeau dat de server bij een betaalde bestelling afboekt (afschrijven, oorzaak `cadeau`). */
export type GiftStockBooking = { ruleId: string; itemId: string }

/**
 * Welke voorraadartikelen een betaalde bestelling als cadeau afboekt. Per bereikte trede (de
 * staffel telt op; gratis verzending niet): het artikel bij de gekozen optie, anders dat van de
 * trede. Een keuze die niet in `choices` staat, valt terug op de eerste (zoals de mand).
 * Een trede zonder gekoppeld artikel boekt niets: een consult of huidplan heeft geen voorraad.
 */
export function giftStockBookings(
  tiers: readonly GiftTier[],
  freeShippingFrom: number,
  subtotal: number,
  chosen: Record<string, string> = {},
): GiftStockBooking[] {
  return [...tiers]
    .sort((a, b) => a.threshold - b.threshold)
    .filter((t) => subtotal >= t.threshold && t.threshold !== freeShippingFrom)
    .flatMap((t) => {
      const choice = t.choices?.length ? (t.choices.includes(chosen[t.ruleId] ?? '') ? chosen[t.ruleId] : t.choices[0]) : null
      const itemId = (choice ? t.choiceStockItems?.[choice] : undefined) ?? t.stockItemId
      return itemId ? [{ ruleId: t.ruleId, itemId }] : []
    })
}
